<template>
  <v-card
    color="grey lighten-5 rounded-0"
    :to="item.to"
    class="d-flex flex-column item"
    height="100%"
    flat
  >
    <img
      :src="item.img + `?resize=1&w=400`"
      :alt="item.title"
      class="d-block item-img"
    />

    <div class="px-2 px-sm-3 py-2 py-sm-5">
      <div
        class="
          grey--text
          text--darken-1
          d-flex
          mb-2
          d-flex
          align-center
          item-details
        "
      >
        <div v-if="item.address" class="d-flex align-baseline">
          <v-icon color="grey lighten-3" :size="xs ? 14 : 16"
            >fas fa-map-marker-alt</v-icon
          >
          <span class="text-body-2 ml-2 grey--text text--lighten-3">
            {{ item.address }}
          </span>
        </div>
        <div v-if="item.date" class="d-flex align-baseline">
          <v-icon color="grey lighten-3" :size="xs ? 14 : 16">
            far fa-calendar
          </v-icon>
          <span class="text-body-2 ml-2 grey--text grey--text text--lighten-3">
            {{ formatDate(item.date, "short") }}
          </span>
        </div>
      </div>

      <div
        v-if="item.title"
        class="text-h6 text-sm-h5 text-uppercase font-weight-bold"
      >
        <div class="item-title grey--text font-barlow">
          {{ item.title }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatDate } from "../../utils/formatDate";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &:hover .item-title {
    color: var(--v-secondary-base) !important;
  }
  &-img {
    aspect-ratio: 263/140;
    border-radius: 8px !important;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  &-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
  }
  &-details {
    display: flex;
    gap: 20px;
  }
}
</style>
